import { useEffect, useLayoutEffect as useRealLayoutEffect } from 'react';
export default process.browser ? useRealLayoutEffect : useEffect;